import { queryOptions } from "@tanstack/react-query";
import { fetchOnboardingState } from "../onboarding";

/**
 * The service resolves which of the three screens to show; this only reads that answer. Never
 * retried automatically — the route's own retry button is the one place a repeat read comes from.
 *
 * Keyed by user, for the same reason `workspacesQueryOptions` is: the answer names another firm
 * when it names one at all — its name, domain and the people who may approve a request — so a
 * second sign-in in the same browser must not read the first one's entry while the cookie-backed
 * refetch is still in flight. Sign-out clears the whole cache as well; this key is the guard if a
 * clear is ever missed.
 */
export function onboardingStateQueryOptions(userId: string) {
  return queryOptions({
    queryKey: ["onboarding-state", userId] as const,
    queryFn: ({ signal }) => fetchOnboardingState(signal),
    retry: false,
  });
}
